import { IAppState } from '../../common/state';
import { getNewbuildingHeaderData } from '../newbuildingHeader';
import { selectIsNewbuildingConsultBannerAvailable } from './selectIsNewbuildingConsultBannerAvailable';

export function selectIsNewbuildingConsultTopBannerAvailable(state: IAppState) {
  const isNewbuildingConsultTopBannerAvailable = selectIsNewbuildingConsultBannerAvailable(state);
  const newbuildingHeaderData = getNewbuildingHeaderData(state);

  if (newbuildingHeaderData.newbuildingInfo || newbuildingHeaderData.isFromDeveloper) {
    return false;
  }

  return isNewbuildingConsultTopBannerAvailable;
}
